<template>
  <div class="main-btn-container">
    <button class="main-btn-button button">{{ button }}</button>
  </div>
</template>

<script>
export default {
  name: 'MainBtn',
  props: {
    button: {
      type: String,
      default: 'Button',
    },
  },
}
</script>

<style scoped>
.main-btn-container {
  display: flex;
  position: relative;
}
.main-btn-button {
  color: var(--dl-color-gray-white);
  border: none;
  transition: 0.3s;
  padding-top: var(--dl-space-space-halfunit);
  padding-left: var(--dl-space-space-doubleunit);
  border-radius: 50px;
  padding-right: var(--dl-space-space-doubleunit);
  padding-bottom: var(--dl-space-space-halfunit);
  background-color: var(--dl-color-primary-100);
}
.main-btn-button:hover {
  background-color: var(--dl-color-primary-500);
}
</style>
